import React from 'react';

interface Props {
  className?: string;
}

const ChevronRightSmall = ({
  className = 'chevron-right-small-icon',
}: Props) => (
  <svg
    className={className}
    width="5"
    height="8"
    viewBox="0 0 5 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.99531 4.95124L1.14611 7.8031C0.883524 8.06563 0.458512 8.06563 0.195925 7.8031C-0.0653083 7.5399 -0.0653083 7.11388 0.195925 6.85203L3.0458 4.00017L0.195925 1.14899C-0.0653083 0.885101 -0.0653083 0.459764 0.195925 0.197914C0.457835 -0.0659714 0.882846 -0.0659714 1.14611 0.197914L3.99531 3.04977L4.46973 3.52463C4.73231 3.78784 4.73231 4.21318 4.46973 4.47571L3.99531 4.95124Z"
      fill="#ffffff"
    />
  </svg>
);

export default ChevronRightSmall;
